import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import React from "react";
import {IModalDialogHandler} from "../../services/dialog/dialog.service.interface";
import {Check} from "@sparkware/app-utils";
import {AboutBox} from "./boxes/about.box";
import {AboutInfoSectionBox} from "./boxes/about-info-section.box";
import {AboutFooterSectionBox} from "./boxes/about-footer-section.box";
import {AreaType} from "@sparkware/uc-sdk-core";
import { CHANNEL_SOURCE } from "../../../common/const/casinofied-analytics-consts";
import { CyClass } from "../../../common/cy-classes";

export interface AboutComponentProps {
    fiscalCode?: string;
    openSessionsBalance?: number;
}

interface AboutComponentInternalProps extends AboutComponentProps {
    dialogHandler: IModalDialogHandler;
    clientVersion: string;
}

export class AboutComponent extends OrbitComponent<AboutComponentInternalProps> {

    componentDidMount() {
        super.componentDidMount();
        this.services.analytics.sendOrbitUserFlowEvent("Client_About", "Open");
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.services.analytics.sendOrbitUserFlowEvent("Client_About", "Close");
    }

    private _handleHelpTextClick = async () => {
        this.services.analytics.sendOrbitUserFlowEvent("Client_About", "Help");
        this.props.dialogHandler.close();
        await (await this.services.appLauncher).openHelpCenter({
            businessCorrelationID: this.services.tools.getGuid(),
            channel: {
                source: CHANNEL_SOURCE.about_popup,
                area: AreaType.button,
            }
        });
    }

    private _renderHelpText = () => {
      if (this.services.miniOrbit.isEnabled) {
          return null;
      }

      return (
        <AboutFooterSectionBox onClick={this._handleHelpTextClick} className={CyClass('cy-about-help-link')}>
            {this.services.translation.translate("ABOUT_HELP_SUPPORT")}
        </AboutFooterSectionBox>
      );
    };

    private _renderAboutInfoSection(sectionTitleKey: string, value: string, valueClass?: string) {
        if (!Check.isEmpty(value)) {
            return (
            <AboutInfoSectionBox>
                <div>{this.services.translation.translate(sectionTitleKey)}</div>
                <div className={valueClass || ''}>{value}</div>
            </AboutInfoSectionBox>
            );
        }
        return null;
    }

    render() {
        const openSessionBalance = Check.isNullOrUndefined(this.props.openSessionsBalance) ? undefined : this.services.currency.formatMoney(this.props.openSessionsBalance);
        return (
          <AboutBox className={"cy-cgp-about-area"}>
              {this._renderAboutInfoSection("ABOUT_SUPPORT_ID_TITLE", this.services.user.cid)}
              {this._renderAboutInfoSection("ABOUT_FISCAL_CODE_TITLE", this.props.fiscalCode)}
                {this._renderAboutInfoSection("ABOUT_OPEN_SESSION_TITLE", openSessionBalance, CyClass("cy-about-session-balance-amount"))}
              {this._renderAboutInfoSection("ABOUT_CLIENT_VERSION_TITLE", this.props.clientVersion)}
              {this._renderHelpText()}
          </AboutBox>
        );
    }
}